import React, {Component} from 'react';
import Slider from 'react-rangeslider'
import classes from './Conditions.css';
import {connect} from 'react-redux';
import MarketConditionsLegend from '../../components/MarketConditionsLegend/MarketConditionsLegend';
import InterestRateLegend from '../../components/InterestRateLegend/InterestRateLegend';
import * as actionTypes from '../../store/actions';

const labels = [
    'Bear',
    'Little Bear',
    'Normal',
    'Little Bull',
    'Bull'
];

export class Conditions extends Component {

    formatLabel = (value) => {
        return labels[value-1];
    };

    render() {

        const horizontalLabels = {
            0: "",
            1: labels[0],
            2: labels[1],
            3: labels[2],
            4: labels[3],
            5: labels[4]
        };

        return (
            <div className={classes.Conditions}>
                <label className={classes.conditionsLabel}>Conditions</label>
                <div className={classes.sliderList}>
                    <div className={classes.sliderSection}>
                        <label>Equity</label>
                        <div className={classes.sliderContainer}>
                            <Slider
                                min={1}
                                max={5}
                                labels={horizontalLabels}
                                value={this.props.equity}
                                onChange={this.props.updateEquity}
                                format={this.formatLabel}
                            />
                        </div>
                    </div>
                    <div className={classes.sliderSection}>
                        <label>Interest Rate</label>
                        <div className={classes.sliderContainer}>
                            <Slider
                                min={1}
                                max={5}
                                labels={horizontalLabels}
                                value={this.props.interest}
                                onChange={this.props.updateInterest}
                                format={this.formatLabel}
                            />
                        </div>
                    </div>
                </div>
                <MarketConditionsLegend/>
                <InterestRateLegend/>
            </div>
        );
    }
};

const mapDispatchToProps = (dispatch) => {

    return {
        updateEquity: (equity) => dispatch({
            type: actionTypes.UPDATE_CONDITION_EQUITY,
            equity: equity
        }),
        updateInterest: (interest) => dispatch({
            type: actionTypes.UPDATE_CONDITION_INTEREST,
            interest: interest
        })
    };

};

export default connect(null, mapDispatchToProps)(Conditions);


// WEBPACK FOOTER //
// ./src/containers/Conditions/Conditions.js